export function getSubdomain(): string | null {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // Dev: abcd.localhost
  if (parts[parts.length - 1] === 'localhost') {
    return parts.length >= 2 && parts[0] !== 'localhost' ? parts[0] : null;
  }

  // Production: subdomain.ischoolnext.com (3+ parts, not www)
  if (parts.length >= 3) {
    const sub = parts[0];
    return sub !== 'www' ? sub : null;
  }

  return null;
}
